import React from 'react';
import { connect } from 'react-redux';
import {Link} from 'react-router-dom';
import { canSupplyStock } from '../content/admin/penjualan/stockAccess';
import { canDeleteStudents } from '../content/admin/import/studentDeletion';

class MenuList extends React.Component{

    componentDidMount(){
        
    }

    renderSubMenu(childMenu){
        if(childMenu){
            return childMenu.map(menu => {
                return(
                    <li key={menu.menuCode}>
                        <Link to={menu.url} className={menu.free === '0' ? "disabled" : ""}>{menu.label}</Link>
                    </li>
                )
            })
        }
    }

    renderMenu(){
        if(this.props.menu.data){
            return this.props.menu.data.map(stream => {
                const id = "#" + stream.menuCode;
                return(
                    <li key={stream.menuCode}>
                        <a href={id} data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">{stream.label}</a>
                        <ul className="collapse list-unstyled" id={stream.menuCode}>
                            {this.renderSubMenu(stream.childMenu)} 
                        </ul> 
                    </li>
                )
            })
        }
    }

    render(){
        return(
            <div>
                {this.renderMenu()}
                {canSupplyStock(this.props.account) && <li><Link to="/stokvoucher">Stok Voucher</Link></li>}
                {canDeleteStudents(this.props.account) && <li><Link to="/delsis">Hapus Akun Siswa</Link></li>}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        menu: state.menu
    }
}

export default connect(mapStateToProps)(MenuList);
